<template>
    <div class="tm-scope tm-auth">
        <div class="tm-auth__wrap">
            <div class="tm-card tm-auth__card tm-reveal">
                <img src="../../assets/images/Logo black.png" class="tm-auth__logo" alt="Topment">
                <h3 class="mb-2">Forgot your password?</h3>
                <p class="tm-body">Password reset isn't available yet. Email us and we'll help you regain access.</p>
                <a class="tm-btn-primary mt-2" href="mailto:admin@topment.fr" style="text-decoration: none;">Contact support</a>
                <div class="tm-auth__foot">
                    Don't have an account?
                    <a class="tm-auth__link" @click="router.push({'name':'signup'})">Sign up</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
    setup() {
        const router = useRouter()
        return {
            router,
        }
    },
})
</script>
<style lang="scss" scoped>
.tm-auth {
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.tm-auth__wrap {
    width: 100%;
    max-width: 400px;
}

.tm-auth__card {
    text-align: center;
    padding: 40px;
}

.tm-auth__logo {
    width: 60px;
    margin: 0 auto 20px;
    display: block;
}

.tm-auth__foot {
    margin-top: 24px;
    font-size: 0.88rem;
    color: var(--tm-ink-muted);
}

.tm-auth__link {
    color: var(--tm-ink);
    font-weight: 500;
    cursor: pointer;
    text-decoration: underline;
}
</style>
